import { useMemo } from 'react';
import { lookupChallenge, DEFAULT_THEME, DEFAULT_SURFACES } from '../data/challengeCatalog';

// Returns the theme tokens for a given challenge id, plus a style object
// that sets them as CSS custom properties for inline use on a wrapper element.
//
// Lookup is tolerant: case-insensitive, treats '-', '_', and space as
// equivalent, so 'Continental Divide', 'continental-divide', and
// 'continental_divide' all resolve to the same catalog entry.
//
// Surfaces (bg + border tokens) are emitted in a page-scoped namespace
// (--gpx-bg-* / --gpx-border-*) so they don't depend on the app-wide
// --bg-* tokens in index.css and survive an app rebrand intact.
export function useChallengeTheme(configId) {
  return useMemo(() => {
    let key = configId;
    if (key && key.includes('%')) {
      try {
        key = decodeURIComponent(key);
      } catch (e) {
        // fall through with the original value
      }
    }
    const entry = key ? lookupChallenge(key) : null;
    const theme = entry?.theme || DEFAULT_THEME;
    const surfaces = entry?.surfaces || DEFAULT_SURFACES;
    const switchCheckpointIndex = entry?.switchCheckpointIndex ?? null;
    const slug = entry?.slug || null;

    const cssVars = {
      '--challenge-primary': theme.primary,
      '--challenge-primary-dark': theme.primaryDark,
      '--challenge-secondary': theme.secondary,
      '--challenge-tint': theme.tint,
      '--challenge-on-primary': theme.onPrimary,
      '--gpx-bg-primary': surfaces.bgPrimary,
      '--gpx-bg-secondary': surfaces.bgSecondary,
      '--gpx-bg-tertiary': surfaces.bgTertiary,
      '--gpx-bg-card': surfaces.bgCard,
      '--gpx-border-primary': surfaces.borderPrimary,
      '--gpx-border-secondary': surfaces.borderSecondary,
      '--gpx-bg-locked': surfaces.bgLocked,
    };

    return { theme, surfaces, switchCheckpointIndex, slug, cssVars, entry };
  }, [configId]);
}
